import Overview from '~/components/Overview'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/lon`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_lon_about_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_lon_about_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}
export default Overview
